'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BreadcrumbsItemStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var size = function size(_ref) {
  var themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var maxWidth = theme.reactackle.components.breadcrumbs.item.maxWidth;
  return (0, _styledComponents.css)(['', ''], maxWidth && 'max-width: ' + (0, _reactackleCore.getValueString)(maxWidth) + ';');
};

var colorScheme = function colorScheme(_ref2) {
  var colorScheme = _ref2.colorScheme,
      themeFromProvider = _ref2.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var color = theme.reactackle.components.breadcrumbs.item.colorScheme[colorScheme].default.color;
  return '\n    color: ' + color + ';\n  ';
};

var BreadcrumbsItemStyled = exports.BreadcrumbsItemStyled = _styledComponents2.default.li.withConfig({
  displayName: 'BreadcrumbsItemStyled'
})(['display:flex;align-items:center;flex-shrink:0;color:inherit;position:relative;user-select:none;', ' ', ''], size, colorScheme);